import { BOOKING_ERROR_CODES, BOOKING_FORM_OUTDATED_MESSAGE } from '@shared/core/bookings'

export function getBookingFormOutdatedMessage(error: unknown): string | null {
  const data = (error as { response?: { data?: { code?: unknown; message?: unknown } } })?.response?.data
  if (data?.code !== BOOKING_ERROR_CODES.bookingFormOutdated) return null
  const serverMessage = typeof data.message === 'string' ? data.message.trim() : ''
  return serverMessage || BOOKING_FORM_OUTDATED_MESSAGE
}
